import React from 'react';
import PropTypes from 'prop-types';
import Button from '../ui/Button';

const ProductActions = ({
  stock,
  price,
  originalPrice,
  quantity,
  onQuantityChange,
  onAddToCart,
  isAvailable
}) => {
  return (
    <div className="space-y-4">
      {/* Quantity Selector */}
      <div className="flex items-center">
        <label htmlFor="quantity" className="mr-3 text-sm font-medium text-gray-700">
          Quantity
        </label>
        <div className="flex items-center border border-gray-300 rounded-md">
          <button
            onClick={() => onQuantityChange(quantity - 1)}
            disabled={quantity <= 1}
            className="px-3 py-1 text-gray-600 disabled:text-gray-300"
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className="px-3 py-1 text-gray-900">{quantity}</span>
          <button
            onClick={() => onQuantityChange(quantity + 1)}
            disabled={quantity >= stock}
            className="px-3 py-1 text-gray-600 disabled:text-gray-300"
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
        <span className="ml-3 text-sm text-gray-500">
          {stock} available
        </span>
      </div>
      
      {/* Add to Cart */}
      <Button
        onClick={onAddToCart}
        variant="primary"
        size="large"
        className="w-full"
        disabled={!isAvailable}
      >
        {isAvailable ? 'Add to Cart' : 'Out of Stock'}
      </Button>
      
      {/* Price Summary */}
      <div className="border-t border-gray-200 pt-4">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal:</span>
          <span className="font-medium">
            ${(price * quantity).toFixed(2)}
          </span>
        </div>
        {originalPrice > price && (
          <div className="flex justify-between text-sm text-gray-500">
            <span>You save:</span>
            <span>
              ${((originalPrice - price) * quantity).toFixed(2)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

ProductActions.propTypes = {
  stock: PropTypes.number,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  quantity: PropTypes.number,
  onQuantityChange: PropTypes.func,
  onAddToCart: PropTypes.func,
  isAvailable: PropTypes.bool
};

export default ProductActions;